(function () {
  'use strict';

  class CategoryTabs {
    constructor() {
      this.tabRow = document.querySelector('.collection-category-tabs__row');
      if (!this.tabRow) return;

      this.tabs = this.tabRow.querySelectorAll('.collection-category-tabs__card');
      this.init();
    }

    init() {
      // Get current collection handle from URL
      const currentHandle = this.getCurrentCollectionHandle();

      // Set active state based on current page
      this.tabs.forEach((tab) => {
        const tabCollection = tab.dataset.collection || '';
        const wrapper = tab.closest('.collection-category-tabs__tab-wrapper');

        // Mark active if this tab's collection matches current page
        if (tabCollection === currentHandle) {
          tab.classList.add('collection-category-tabs__card--active');
          tab.setAttribute('aria-selected', 'true');
          if (wrapper) wrapper.classList.add('collection-category-tabs__tab-wrapper--active');
        } else {
          tab.classList.remove('collection-category-tabs__card--active');
          tab.setAttribute('aria-selected', 'false');
          if (wrapper) wrapper.classList.remove('collection-category-tabs__tab-wrapper--active');
        }

        // Click = navigate to that collection page
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          if (tabCollection && tabCollection !== currentHandle) {
            window.location.href = '/collections/' + tabCollection;
          }
        });
      });
    }

    getCurrentCollectionHandle() {
      const match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
      return match ? match[1] : '';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new CategoryTabs());
  } else {
    new CategoryTabs();
  }
})();
